<template>
  <div>
    <div class="wrapper wrapper-content  animated fadeInRight">
      <modal-form modal-id="add-user" animation="fadeInRight">
        <div slot="title">Add New User</div>
        <div slot="form">
          <div class="form-group">
            <div class="row">
              <div class="col-lg-3">Name</div>
              <div class="col-lg-9">
                <input type="text" name="" class="form-control" v-model="addUser['name']">
              </div>
            </div>
            <div class="row m-t-sm">
              <div class="col-lg-3">Username</div>
              <div class="col-lg-9">
                <input type="text" name="" class="form-control" v-model="addUser['username']">
              </div>
            </div>
            <div class="row m-t-sm">
              <div class="col-lg-3">Password</div>
              <div class="col-lg-9">
                <input type="text" name="" class="form-control" v-model="addUser['password']">
              </div>
            </div>
            <div class="row m-t-sm">
              <div class="col-lg-3">Email</div>
              <div class="col-lg-9">
                <input type="email" name="" class="form-control" v-model="addUser['email']">
              </div>
            </div>
            <div class="row m-t-sm">
              <div class="col-lg-3">Groups</div>
              <div class="col-lg-9">
                <v-select
                  :options="f.groups"
                  multiple
                  v-model="addUser['groups']"
                  label="name"
                  index="id"
                ></v-select>
              </div>
            </div>
            <div class="row m-t-sm">
              <div class="col-lg-3">Active</div>
              <div class="col-lg-9">
                <v-select :options="[{val: 'false', txt: 'No'}, {val: 'true', txt: 'Yes'}]" :clearable="false" label="txt" index="val" v-model="addUser['active']"></v-select>
              </div>
            </div>
            <div class="row m-t-md">
              <div class="col-lg-12">
                <button class="btn btn-sm btn-primary" @click="saveUser">Save</button>
              </div>
            </div>
          </div>
        </div>
      </modal-form>
      <div class="ibox-title">
        <h5>Users</h5>
        <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-user">Add user</button>
      </div>
      <div class="ibox-content col-lg-12">
        <filters/>
        <div class="col-lg-12 m-t-sm"></div>
        <list/>
      </div>
    </div>
  </div>
</template>
<script>
import Filters from './Users/Filters'
import List from './Users/List'
import { mapGetters } from 'vuex'
import Modal from '../../Helpers/Modal/Form'
import axios from 'axios'
import { eventBus } from '../../../main'

export default {
  data () {
    return {
      addUser: {}
    }
  },
  components: {
    Filters,
    List,
    ModalForm: Modal
  },
  computed: {
    ...mapGetters({
      roles: 'getUserRoles',
      f: 'getFilters'
    })
  },
  mounted () {
    document.title = 'Users :: PBN360 by Aphex Media'
    if (!this.f.groups) {
      this.$store.dispatch('loadFilters')
    }
  },
  methods: {
    saveUser () {
      const addUser = {...this.addUser}
      if (!addUser.username || !addUser.password || !addUser.email) {
        this.$toastr.error('Some data seems to be missing')
        return
      }

      addUser.active = addUser.active === 'true' ? 1 : 0

      axios.post('/client/user', addUser)
        .then(r => {
          $('#add-user').modal('hide')
          this.$toastr.success('User Account Created')
          eventBus.$emit('reloadUsers')
        })
        .catch(e => {
          const msg = e.response ? e.response.data.msg : 'Account creation failed'
          this.$toastr.error(e, msg)
        })
      // Reset form to defaults
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/ClientAccount/Users.vue